// extracted by mini-css-extract-plugin
module.exports = {"mapWrapper":"speedIndexLocation_mapWrapper_1btzo0f"};